"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableText = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

function EditableText(_ref) {
  var children = _ref.children,
      style = _ref.style,
      onChange = _ref.onChange;
  return react_1.default.createElement(antd_1.Typography.Paragraph, {
    children: children,
    style: style,
    editable: {
      onChange: onChange
    }
  });
}

exports.EditableText = EditableText;